import { PageData } from '../types'

export const PAGES: PageData[] = [
  {
    id: 0,
    title: 'Title',
    navSection: 'Overview',
    timebox: '10s',
    notes: ['10 seconds: set calm tone; confirm time and structure.'],
  },
  {
    id: 1,
    title: 'Agenda & Demo',
    navSection: 'Overview',
    timebox: '1m',
    notes: [
      'Invite questions; show parking lot toggle; state time discipline.',
    ],
  },
  {
    id: 2,
    title: 'Who I am',
    navSection: 'You',
    timebox: '2m',
    notes: ["Keep it snappy; focus on 'builder + motion + outcomes'."],
  },
  {
    id: 3,
    title: 'Signature strengths',
    navSection: 'You',
    timebox: '2m',
    notes: ['Tie each to what Sierra needs now: scale beyond heroics.'],
  },
  {
    id: 4,
    title: 'Proof metrics',
    navSection: 'You',
    timebox: '2m',
    notes: [
      'I care about measurable impact - pipeline, conversion, time-to-value.',
    ],
  },
  {
    id: 5,
    title: 'Deal snapshot',
    navSection: 'Deal Review',
    timebox: '2m',
    notes: ['This shows how I win against incumbents: risk + ROI + craft.'],
  },
  {
    id: 6,
    title: 'Obstacles + what I did',
    navSection: 'Deal Review',
    timebox: '4m',
    notes: ["I didn't argue - I built evidence and reduced risk."],
  },
  {
    id: 7,
    title: 'Turning point + outcome',
    navSection: 'Deal Review',
    timebox: '3m',
    notes: ['Deliver this like a punchline; then transition to ACME.'],
  },
  {
    id: 8,
    title: 'ACME Telco: discovery',
    navSection: 'ACME Demo',
    timebox: '2m',
    notes: ["Here's what success looks like, in measurable terms."],
  },
  {
    id: 9,
    title: 'Use case selection',
    navSection: 'ACME Demo',
    timebox: '2m',
    notes: ['Set expectation: one end-to-end hero journey, two highlights.'],
  },
  {
    id: 10,
    title: 'DEMO MODE',
    navSection: 'ACME Demo',
    timebox: '15m',
    notes: [
      "I'm going to verify identity before we change account state.",
      "Now we'll check entitlement and issue the eSIM.",
      "Here's the confirmation gate before activation.",
    ],
  },
  {
    id: 11,
    title: 'Architecture',
    navSection: 'Architecture',
    timebox: '5m',
    notes: ['Use a 2-minute talk track version and a 30-second version.'],
  },
  {
    id: 12,
    title: 'Proof tiles',
    navSection: 'Proof',
    timebox: '2m',
    notes: ['Keep it short; pick 2–3 tiles to say out loud.'],
  },
  {
    id: 13,
    title: 'Closing',
    navSection: 'Close',
    timebox: '3m',
    notes: [
      "End with one sentence: 'Happy to take questions - or I can revisit anything in the parking lot.'",
    ],
  },
  {
    id: 14,
    title: 'Questions?',
    navSection: 'Q&A',
    timebox: '5m',
    notes: ['Answer crisply, return to parked questions, close politely.'],
  },
  {
    id: 15,
    title: 'Appendix: Rollout Plan',
    navSection: 'Appendix',
    notes: ['Appendix slide.'],
  },
  {
    id: 16,
    title: 'Appendix: Enterprise-Grade Trust',
    navSection: 'Appendix',
    notes: ['Appendix slide.'],
  },
  {
    id: 17,
    title: 'Appendix: Detailed Q&A',
    navSection: 'Appendix',
    notes: ['Appendix slide.'],
  },
  {
    id: 18,
    title: 'Appendix: Values Aligned',
    navSection: 'Appendix',
    notes: ['Appendix slide.'],
  },
  {
    id: 19,
    title: 'Appendix: 90-Day Plan',
    navSection: 'Appendix',
    notes: ['Appendix slide.'],
  },
  {
    id: 20,
    title: 'Cheat Sheet',
    navSection: 'Hidden',
    notes: [],
  },
]
